module.exports = __webpack_public_path__ + "media/images/loader_logo-8ad6e8d48002e9f6bfa0007d2a0680c2.png";